<template>

	<div>

		<new-group-form v-on:group-changed="refreshGroupList"></new-group-form>

		<group-list can_manage_groups title="Groups" ref="groupList"></group-list>

	</div>

</template>

<script>
	export default {
		data: function () {
				return {
				}
		},
		computed: {
		},
		mounted() {
				console.log('Groups Page component mounted.');
		},
		methods: {
			refreshGroupList() {
				this.$refs.groupList.refreshGroupList();
			},
		}
	}
</script>